import React from 'react';
import { motion } from 'framer-motion';
import { Hero } from '../components/Hero';
import { Section } from '../components/Section';
import { Button } from '../components/Button';
import { Footer } from '../components/Footer';
import { Check, X, Heart, ShieldCheck, Download, Star, Clock, Battery, Brain, Lock, BookOpen } from 'lucide-react';
export function SalesPage() {
  return <div className="min-h-screen bg-[#FBF8F3] overflow-x-hidden" data-id="element-149">
      <Hero data-id="element-150" />

      {/* 2. EL MOMENTO EXACTO */}
      <Section className="bg-white/40" data-id="element-151">
        <div className="text-center max-w-3xl mx-auto mb-8" data-id="element-152">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#5C4A3A] mb-4" data-id="element-153">
            Hay un cansancio que no se quita durmiendo.
          </h2>
          <p className="text-base text-[#5C4A3A]/80 leading-relaxed" data-id="element-154">
            Es el cansancio de sostenerlo todo: responsabilidades, emociones de
            otros, exigencias ajenas… y encima, exigirte a ti misma estar bien.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 items-center" data-id="element-155">
          <div className="bg-[#FBF8F3] p-6 rounded-2xl border border-[#E8A87C]/20" data-id="element-156">
            <h3 className="font-serif text-lg font-semibold mb-3 text-[#E8A87C]" data-id="element-157">
              Cuando vives así por mucho tiempo:
            </h3>
            <ul className="space-y-3" data-id="element-158">
              {['Cuesta decir que no sin sentir culpa', 'Te pierdes en las necesidades de otros', 'Lo que no has cerrado del pasado sigue pesando'].map((item, i) => <li key={i} className="flex items-start" data-id="element-159">
                  <X className="h-4 w-4 text-red-400 mt-1 mr-2 flex-shrink-0" data-id="element-160" />
                  <span className="text-[#5C4A3A]/80 text-sm" data-id="element-161">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="text-center md:text-left" data-id="element-162">
            <p className="text-lg md:text-xl font-serif italic text-[#5C4A3A] mb-4" data-id="element-163">
              "Esta guía es para cortar con ese ciclo."
            </p>
            <div className="h-1 w-24 bg-[#E8A87C] rounded-full mx-auto md:mx-0 opacity-50" data-id="element-164"></div>
          </div>
        </div>
      </Section>

      {/* 3. QUÉ ES / QUÉ NO ES */}
      <Section data-id="element-165">
        <div className="bg-white rounded-3xl p-6 md:p-10 shadow-xl shadow-[#E8A87C]/5 border border-[#E8A87C]/10" data-id="element-166">
          <div className="text-center mb-8" data-id="element-167">
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-168">
              Transforma tu Vida: Un Nuevo Comienzo
            </h2>
            <p className="text-base text-[#5C4A3A]/80 max-w-2xl mx-auto" data-id="element-169">
              Un PDF de{' '}
              <span className="font-semibold text-[#E8A87C]" data-id="element-170">49 páginas</span>{' '}
              creado para mujeres que están emocionalmente agotadas, que sienten
              que perdieron sus propios límites y que necesitan cerrar ciclos.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-171">
            <div data-id="element-172">
              <h3 className="font-serif text-lg font-bold mb-3 text-[#5C4A3A] flex items-center" data-id="element-173">
                <X className="h-4 w-4 text-red-400 mr-2" data-id="element-174" /> Lo que NO es
              </h3>
              <ul className="space-y-2 text-[#5C4A3A]/80 text-sm" data-id="element-175">
                <li className="flex items-center gap-2" data-id="element-176">
                  <span className="w-1.5 h-1.5 bg-red-300 rounded-full" data-id="element-177"></span>
                  No es teoría aburrida
                </li>
                <li className="flex items-center gap-2" data-id="element-178">
                  <span className="w-1.5 h-1.5 bg-red-300 rounded-full" data-id="element-179"></span>
                  No es motivación superficial
                </li>
              </ul>
            </div>
            <div data-id="element-180">
              <h3 className="font-serif text-lg font-bold mb-3 text-[#5C4A3A] flex items-center" data-id="element-181">
                <Check className="h-4 w-4 text-green-500 mr-2" data-id="element-182" /> Lo que SÍ es
              </h3>
              <p className="text-[#5C4A3A]/80 text-sm bg-[#FBF8F3] p-4 rounded-xl border border-[#E8A87C]/20" data-id="element-183">
                Un camino claro para soltar lo que te agota, recuperar tus
                límites y empezar con más calma.
              </p>
            </div>
          </div>

          <div className="text-center" data-id="element-184">
            <div className="flex flex-col items-center gap-2 mb-2" data-id="element-185">
              <div className="flex items-center gap-3" data-id="element-186">
                <span className="text-[#5C4A3A]/40 line-through text-base" data-id="element-187">
                  US$19.97
                </span>
                <span className="bg-[#E8A87C] text-white px-2.5 py-0.5 rounded-full text-xs font-bold" data-id="element-188">
                  68% OFF
                </span>
              </div>
            </div>
            <Button className="w-full sm:w-auto" scrollToId="cta-final" data-id="element-189">
              Sí, quiero empezar hoy — US$6.39
            </Button>
          </div>
        </div>
      </Section>

      {/* 4. PARA QUIÉN ES */}
      <Section className="bg-[#5C4A3A] text-[#FBF8F3]" data-id="element-190">
        <div className="grid md:grid-cols-2 gap-8 md:gap-16" data-id="element-191">
          <div data-id="element-192">
            <h3 className="text-xl font-serif font-bold mb-4 text-[#E8A87C]" data-id="element-193">
              Esta guía es para ti si…
            </h3>
            <ul className="space-y-3" data-id="element-194">
              {['Te sientes drenada de sostener todo', 'Te cuesta poner límites sin sentirte culpable', 'Cargas con emociones del pasado que no has soltado', 'Quieres un camino sin exigencias para empezar un nuevo rumbo'].map((item, i) => <li key={i} className="flex items-start" data-id="element-195">
                  <Check className="h-4 w-4 text-[#E8A87C] mt-1 mr-2 flex-shrink-0" data-id="element-196" />
                  <span className="text-[#FBF8F3]/90 text-base" data-id="element-197">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white/5 p-6 rounded-2xl border border-white/10" data-id="element-198">
            <h3 className="text-xl font-serif font-bold mb-4 text-white/80" data-id="element-199">
              No es para ti si…
            </h3>
            <ul className="space-y-3" data-id="element-200">
              {['Esperas resultados mágicos en 24 horas', 'No estás dispuesta a practicar con honestidad', 'Solo buscas frases bonitas sin un cambio real'].map((item, i) => <li key={i} className="flex items-start" data-id="element-201">
                  <X className="h-4 w-4 text-white/40 mt-1 mr-2 flex-shrink-0" data-id="element-202" />
                  <span className="text-white/70 text-base" data-id="element-203">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </Section>

      {/* 5. RESULTADOS */}
      <Section data-id="element-204">
        <div className="text-center mb-8" data-id="element-205">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-206">
            Al terminar, vas a notar que es más fácil:
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-207">
          {[{
          icon: Brain,
          text: 'Calmar el ruido mental y recuperar claridad'
        }, {
          icon: Heart,
          text: 'Soltar culpas que antes te detenían'
        }, {
          icon: Clock,
          text: 'Cerrar ciclos sin quedarte atrapada en el pasado'
        }, {
          icon: ShieldCheck,
          text: 'Poner límites con más firmeza y menos culpa'
        }, {
          icon: Battery,
          text: 'Recuperar tu energía emocional poco a poco'
        }, {
          icon: Star,
          text: 'Darte una dirección clara para un nuevo comienzo'
        }].map((item, i) => <motion.div key={i} whileHover={{
          y: -5
        }} className="bg-white p-5 rounded-xl shadow-sm border border-[#E8A87C]/10 flex flex-col items-center text-center hover:shadow-md transition-all" data-id="element-208">
              <div className="w-10 h-10 bg-[#FFF5F0] rounded-full flex items-center justify-center mb-3 text-[#E8A87C]" data-id="element-209">
                <item.icon className="h-5 w-5" data-id="element-210" />
              </div>
              <p className="text-[#5C4A3A] font-medium text-sm" data-id="element-211">{item.text}</p>
            </motion.div>)}
        </div>
      </Section>

      {/* 6. EL MÉTODO */}
      <Section className="bg-white/60" data-id="element-212">
        <div className="max-w-3xl mx-auto" data-id="element-213">
          <div className="text-center mb-8" data-id="element-214">
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-215">
              No se trata de cambiar todo de golpe.
            </h2>
            <p className="text-base text-[#5C4A3A]/70" data-id="element-216">
              Se trata de avanzar en este orden:
            </p>
          </div>

          <div className="space-y-4 relative before:absolute before:left-[17px] before:top-0 before:bottom-0 before:w-0.5 before:bg-[#E8A87C]/20" data-id="element-217">
            {[{
            title: 'Decisión y cierre',
            desc: 'Dejar de cargar con lo que ya no va contigo.'
          }, {
            title: 'Energía y límites',
            desc: 'Proteger tu energía sin convertirte en alguien fría.'
          }, {
            title: 'Movimiento y mente',
            desc: 'Recuperar estabilidad desde el cuerpo y la mente.'
          }, {
            title: 'Propósito y celebración',
            desc: 'Asegurar que no vuelves al mismo punto después.'
          }].map((step, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start relative z-10" data-id="element-218">
                <div className="w-9 h-9 bg-[#E8A87C] text-white rounded-full flex items-center justify-center font-bold text-base flex-shrink-0 mr-3 shadow-lg shadow-[#E8A87C]/30" data-id="element-219">
                  {i + 1}
                </div>
                <div className="bg-white p-5 rounded-xl shadow-sm border border-[#E8A87C]/10 flex-1" data-id="element-220">
                  <h3 className="font-serif text-lg font-bold text-[#5C4A3A] mb-1" data-id="element-221">
                    {step.title}
                  </h3>
                  <p className="text-[#5C4A3A]/70 text-sm" data-id="element-222">{step.desc}</p>
                </div>
              </motion.div>)}
          </div>

          <div className="mt-6 text-center" data-id="element-223">
            <p className="text-[#5C4A3A]/80 italic text-sm" data-id="element-224">
              Este orden es lo que evita que te sientas bien solo un momento y
              luego vuelvas al mismo agotamiento.
            </p>
          </div>
        </div>
      </Section>

      {/* 7. QUÉ HAY DENTRO */}
      <Section data-id="element-225">
        <div className="bg-[#5C4A3A] text-[#FBF8F3] rounded-3xl p-6 md:p-12 relative overflow-hidden" data-id="element-226">
          {/* Decorative circles */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl" data-id="element-227"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#E8A87C]/10 rounded-full translate-y-1/2 -translate-x-1/2 blur-3xl" data-id="element-228"></div>

          <h2 className="text-2xl md:text-3xl font-serif font-bold mb-6 text-center relative z-10" data-id="element-229">
            Qué hay dentro de la guía
          </h2>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-2 relative z-10" data-id="element-230">
            {['Decidir cambiar es el primer paso', 'Cierra ciclos con gratitud', 'Tu cuerpo merece atención y respeto', 'Tu mente necesita espacio y silencio', 'Protege tu energía como un tesoro', 'Aprende a decir NO sin culpa', 'Rutinas que te sostienen en el cambio', 'Pensamiento positivo (más allá de frases bonitas)', 'Rodéate de personas que suman', 'Visualiza tu nueva vida', 'Celebra tu transformación cada día'].map((chapter, i) => <div key={i} className="flex items-center border-b border-white/10 py-2" data-id="element-231">
                <span className="text-[#E8A87C] mr-2 text-xs font-mono" data-id="element-232">
                  {(i + 1).toString().padStart(2, '0')}
                </span>
                <span className="text-[#FBF8F3]/90 text-sm" data-id="element-233">{chapter}</span>
              </div>)}
          </div>
        </div>
      </Section>

      {/* 8. ENTREGA */}
      <Section className="bg-white" data-id="element-234">
        <div className="grid md:grid-cols-3 gap-6 text-center" data-id="element-235">
          {[{
          icon: Download,
          title: 'Acceso inmediato',
          desc: 'Descarga el PDF en el momento + lo recibes en tu correo.'
        }, {
          icon: Clock,
          title: 'A tu ritmo',
          desc: 'Lo lees a tu ritmo, sin presión ni horarios.'
        }, {
          icon: Star,
          title: 'Sin fricción',
          desc: 'Pasos cortos, claros y prácticos para avanzar aunque tengas poco tiempo.'
        }].map((item, i) => <div key={i} className="p-4" data-id="element-236">
              <div className="w-14 h-14 bg-[#FBF8F3] rounded-full flex items-center justify-center mx-auto mb-4 text-[#E8A87C]" data-id="element-237">
                <item.icon className="h-7 w-7" data-id="element-238" />
              </div>
              <h3 className="font-serif text-lg font-bold text-[#5C4A3A] mb-2" data-id="element-239">
                {item.title}
              </h3>
              <p className="text-[#5C4A3A]/70 text-sm" data-id="element-240">{item.desc}</p>
            </div>)}
        </div>
      </Section>

      {/* 9. GARANTÍA */}
      <Section data-id="element-241">
        <div className="max-w-2xl mx-auto text-center bg-white p-6 md:p-10 rounded-2xl border-2 border-[#E8A87C]/20 shadow-xl shadow-[#E8A87C]/5" data-id="element-242">
          <div className="w-14 h-14 bg-[#E8A87C] rounded-full flex items-center justify-center mx-auto mb-4 text-white shadow-lg shadow-[#E8A87C]/30" data-id="element-243">
            <Lock className="h-7 w-7" data-id="element-244" />
          </div>
          <h2 className="text-xl md:text-2xl font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-245">
            Garantía total de 7 días
          </h2>
          <p className="text-[#5C4A3A]/80 mb-0 leading-relaxed text-sm" data-id="element-246">
            Si no es lo que esperabas, tienes 7 días para pedir tu reembolso con
            un simple correo. Sin preguntas, sin complicaciones. Quiero que te
            sientas segura con tu decisión.
          </p>
        </div>
      </Section>

      {/* 10. CTA FINAL */}
      <Section className="pb-20" id="cta-final" data-id="element-247">
        <div className="text-center max-w-3xl mx-auto" data-id="element-248">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#5C4A3A] mb-4" data-id="element-249">
            Es tu momento de soltar.
          </h2>
          <p className="text-lg text-[#5C4A3A]/80 mb-8" data-id="element-250">
            Si estás cansada de cargar con todo, este es tu momento para poner
            límites y empezar algo nuevo.
          </p>

          <div className="flex flex-col items-center gap-5" data-id="element-251">
            <div className="flex flex-col items-center gap-2" data-id="element-252">
              <div className="flex items-center gap-3" data-id="element-253">
                <span className="text-[#5C4A3A]/40 line-through text-lg" data-id="element-254">
                  US$19.97
                </span>
                <span className="bg-[#E8A87C] text-white px-3 py-1 rounded-full text-sm font-bold" data-id="element-255">
                  68% OFF
                </span>
              </div>
              <Button className="text-lg px-10 py-5 shadow-xl shadow-[#E8A87C]/30" data-id="element-256">
                Comprar ahora — US$6.39
              </Button>
            </div>

            <div className="flex flex-wrap justify-center gap-3 text-xs text-[#5C4A3A]/60" data-id="element-257">
              <span className="flex items-center" data-id="element-258">
                <Download className="h-3.5 w-3.5 mr-1" data-id="element-259" /> PDF (49 páginas)
              </span>
              <span className="hidden sm:inline" data-id="element-260">•</span>
              <span className="flex items-center" data-id="element-261">
                <BookOpen className="h-3.5 w-3.5 mr-1" data-id="element-262" /> Descarga inmediata
              </span>
              <span className="hidden sm:inline" data-id="element-263">•</span>
              <span className="flex items-center" data-id="element-264">
                <ShieldCheck className="h-3.5 w-3.5 mr-1" data-id="element-265" /> Garantía 7 días
              </span>
            </div>
          </div>
        </div>
      </Section>

      <Footer data-id="element-266" />
    </div>;
}